// extracted by mini-css-extract-plugin
export default {"coaches":"TeamCoaches_coaches__7kVEh","name":"TeamCoaches_name__zuXTY","pointer":"TeamCoaches_pointer__JERqI"};